export default function AJAX_ASP() {
  return (
    <div>
      <h1>AJAX_ASP</h1>
      <p>This is the AJAX_ASP component.</p>
    </div>
  );
}